import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const FacebookIcon = ({width}) => { 
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "facebook.png" }) {
        childImageSharp {
        fluid(maxWidth: 100, quality: 10) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
 
  return (
    <div style={{width: `${width}px`, marginRight: '10px'}}>
      <a href='https://www.facebook.com/canborneo/' target='_blank' rel="noopener noreferrer">
        <Img fluid={data.placeholderImage.childImageSharp.fluid} />
      </a>
    </div>
  )
}

export default FacebookIcon
